import { ca } from '@cian/analytics';

export function trackToastShow() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'DailyrentInformer',
    action: 'Show',
    label: 'PriceRestriction',
    page: {
      pageType: 'Map',
      siteType: 'mobile',
    },
  });
}
